import { PendingReportCreate } from '../../../../application/ReportsQueueService';

export enum PendingReportsActionType {
  SET_PENDING_REPORTS = `SET_PENDING_REPORTS`,
}

export interface SetPendingReportsAction {
  type: PendingReportsActionType.SET_PENDING_REPORTS;
  payload: PendingReportCreate[];
}

export type PendingReportsActions = SetPendingReportsAction;
